<template>
	<div class="tooltip-wrap" ref="holder" @mouseover="open = true" @mouseout="open = false">
		<slot></slot>
		<transition name="fade" mode="out-in">
			<div class="tooltip" v-if="open" :style="style" ref="tooltip">{{ tip }}</div>
		</transition>
	</div>
</template>

<script>
	export default {
		props: ['tip', 'direction'],
		data() {
			return {
				open: false,
				holder: {x: 0, y: 0, width: 0, height: 0},
				tooltip: {x: 0, y: 0, width: 0, height: 0}
			};
		},
		watch: {
			async open() {
				if(!this.open) {
					return;
				}
				await this.$nextTick();
				const holder = this.$refs.holder.getBoundingClientRect();
				const tooltip = this.$refs.tooltip.getBoundingClientRect();
				this.holder = {x: holder.x, y: holder.y, width: holder.width, height: holder.height};
				this.tooltip = {x: tooltip.x, y: tooltip.y, width: tooltip.width, height: tooltip.height};
			}
		},
		computed: {
			style() {
				if(this.direction === 'down') {
					return {
						top: this.holder.height + 'px',
						left: ((this.holder.width - this.tooltip.width) / 2) + 'px'
					};
				}
				return {'top': '-100%'};
			}
		}
	}
</script>